import {
  CatchAPIService,
  MerchantId,
  SetHeaderService
} from "@/helper/userHelper";
import service from "../baseHttpService";

class ContactService {
  DoGetAllContact(isUseMainDatabase = false) {
    const _input: any = {
      merchantId: MerchantId(),
      isUseMainDatabase: isUseMainDatabase
    };

    return service.peakExportAPI
      .post("/api/Contact/GetAllContact", _input, SetHeaderService())
      .then(res => {
        return res;
      })
      .catch(err => CatchAPIService(err.response));
  }
}

export default new ContactService();
